import { MsgTemplate } from '../../schema/message/inferface';

export const getNoIntentTemplate = (
  url: string,
  type: 'document' | 'image',
  text: string,
  filename?: string
): MsgTemplate => {
  return {
    media: {
      params: [
        {
          type: 'header',
          parameters: [
            { type: type, [type]: { link: url, filename: filename } },
          ],
        },
      ],
      components: [
        {
          type: 'HEADER',
          format:
            type === 'image'
              ? 'IMAGE'
              : type === 'document'
                ? 'DOCUMENT'
                : undefined,
        },
        { type: 'BODY', text: text },
      ],
    },
  };
};
